module.exports = __webpack_public_path__ + "img/star-2.e490a4a1.svg";